var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SideBar',{attrs:{"width":_vm.getSideBarWidth()},scopedSlots:_vm._u([{key:"side-bar-activator",fn:function(){return [_c('Activator',{key:`side_bar_activator>`,staticClass:"self-centered cursor-e-resize",nativeOn:{"mousedown":function($event){_vm.location.includes('HistProjectTaktPlan') ? _vm.$router.push({name: 'HistProjectTaktPlan'}) :_vm.$router.push({name: 'ProjectTaktPlan'})}}})]},proxy:true},{key:"content",fn:function(){return [_c('div',{staticStyle:{"position":"relative","width":"100%","height":"100%","overflow":"hidden"}},[_c('BacklogWrapper',{attrs:{"color":"grey darken-3","isEditMode":_vm.isEditMode,"type":"backlogsheader","text":"Backlogs","small_width":_vm.$route.matched.length > 3?true:false},on:{"clickAdd":function($event){_vm.createUObject({
            url: [
              {projects: _vm.project.id},
              {wbgroups: ''},
              {showWithEntitiesNormalized: ''}
            ],
            u_object: {
              name: 'New Group',
              description: 'description'
            },
            trainsbacklogs: true
          }).then(group_id => {
            _vm.createUObject({
              url: [
                {projects: _vm.project.id},
                {wbgroups: group_id},
                {wblines: ''},
                {showWithEntitiesNormalized: ''}
              ],
                u_object: {
                  name: 'New Line',
                  description: 'description',
                  position: 1
                }
              })
            })}},scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('div',{staticStyle:{"margin-right":"32px","margin-top":"-4px"}},[_c('TTooltip',{attrs:{"bottom":"","text":"Filter no date"}},[_c('ToggleCapsule',{attrs:{"is_active":_vm.$store.state.View.backglogs_show_with_date,"background_color":"#121212","foreground_color":"#FFF"},on:{"toggleClicked":function($event){return _vm.setValue({ key: 'backglogs_show_with_date', value: !_vm.$store.state.View.backglogs_show_with_date})}}})],1)],1)]},proxy:true},(_vm.$route.matched[3])?{key:"right",fn:function(){return [_c('div',{class:`pa-1 ${_vm.workpackage?_vm.workpackage.color:''}`,staticStyle:{"position":"relative","width":"100%","display":"flex","align-items":"center","margin-left":"10px"}},[_c('v-btn',{attrs:{"small":""},on:{"click":function($event){return _vm.handleBackClick()}}},[_c('v-icon',[_vm._v(" keyboard_arrow_left ")]),_vm._v(" Back ")],1),(_vm.$route.matched[3] && _vm.$route.matched[3].name === 'TaktPlanAddWBWorkPackage')?_c('TText',{staticClass:"ml-2",attrs:{"text":"Add WB Workpackage","medium":""}}):(_vm.workpackage && _vm.isEditMode)?[_c('v-spacer'),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();_vm.show_header_options = !_vm.show_header_options}}},[_c('TIcon',{attrs:{"color":_vm.workpackage.textcolor,"name":"vertical-dots"}})],1),_c('TransitionAccordion',[(_vm.show_header_options)?_c('PopUpOverlay',{staticStyle:{"z-index":"20"},attrs:{"width":`${2 * 140}px`,"margin":8,"position_css":`
                    right: 10px;
                    transform: translate(0%, 100%);
                  `,"is_no_cancel":true,"z_index":1},on:{"closeOverlay":function($event){_vm.show_header_options = false}},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('div',{staticClass:"workpackage-sidebar-option-buttons"},[_c('ClickablePopUpIcon',{attrs:{"icon":"pencil","color":"var(--primary)","description":"edit"},on:{"selected":function($event){_vm.edit_wp = _vm.workpackage, _vm.show_header_options = false}}}),_c('ClickablePopUpIcon',{attrs:{"icon":"copy","color":"var(--primary)","description":"copy"},on:{"selected":function($event){_vm.getNestedWorkPackageCopy(_vm.workpackage.id, false, 'wb').then(work_package => {
                            _vm.updateWBLObject({
                            path: [
                            {workpackage: ''}
                            ],
                            update: work_package
                            }),
                            _vm.$router.push({
                              name: 'TaktPlanBacklogWorkPackageCopyWorkPackageEditor',
                              params: { workpackage_id: 'create' }
                            })
                          }), _vm.show_header_options = false}}}),_c('DropDownModular',{staticStyle:{"padding":"0px"},attrs:{"selected":_vm.selectedWBLine,"options":_vm.getAllWBLines(),"justify_content":"center","z_index":"12","padding":"0 8","max_height":"400"},on:{"updateSelected":function($event){_vm.changeLineWBWorkpackage($event), _vm.show_header_options = false}},scopedSlots:_vm._u([{key:"head",fn:function(){return [_c('div',[_c('TIcon',{staticClass:"ml-4",attrs:{"name":"swap-vertical","color":"var(--primary)","size":30}}),_c('TText',{staticStyle:{"margin-top":"0px"},attrs:{"value":"change line","size":9}})],1)]},proxy:true}],null,false,3445010428)}),_c('div',{staticClass:"workpackage-sidebar-deletebutton-wrapper"},[_c('StandardDeleteButton',{staticClass:"mt-1 ml-1",attrs:{"zoom":1},on:{"clickDelete":function($event){_vm.deleteUObject({
                            url: [
                              {projects: _vm.$route.params.project_id},
                              {wbgroups: _vm.$route.params.wbgroup_id},
                              {wblines: _vm.$route.params.wbline_id},
                              {wbworkpackages: _vm.workpackage.id}
                            ],
                          }).then(() => {
                            _vm.$router.push({name: 'TaktPlanBacklogs'})
                          })}}}),_c('TText',{staticStyle:{"margin-top":"5px"},attrs:{"value":"delete","size":9,"color":"var(--primary)"}})],1)],1)]},proxy:true}],null,false,1922929109)}):_vm._e()],1),(_vm.edit_wp)?_c('EditTWorkPackageDialog',{attrs:{"workpackage":_vm.edit_wp,"backlog":true},on:{"closeDialog":function($event){_vm.edit_wp = false},"changeWP":function($event){_vm.updateUObject({
                  url: [
                  {projects: _vm.$route.params.project_id},
                  {wbgroups: _vm.$route.params.wbgroup_id},
                  {wblines: _vm.$route.params.wbline_id},
                  {wbworkpackages: _vm.workpackage.id}
                  ],
                  update: $event.new_wp,
                  }).then(() => {
                    _vm.edit_wp = false;
                    })}}}):_vm._e()]:_vm._e()],2)]},proxy:true}:null],null,true)}),_c('div',{staticStyle:{"position":"relative","display":"flex","width":"100%","height":"100%","overflow":"hidden"}},[_c('div',{staticStyle:{"position":"relative","display":"flex","flex-direction":"column","flex-shrink":"0","height":"100%","overflow":"auto","scrollbar-gutter":"stable"}},_vm._l((_vm.getUObjects({type: 'wbgroups', ids: _vm.project.wbgroups})),function(wbgroup){return _c('BacklogWrapper',{key:`wbgroups-${wbgroup.id}`,attrs:{"isEditMode":_vm.isEditMode,"color":"#616161","icon":"crop_landscape","type":"wbgroups","header_sticky_position":"0px","small_width":_vm.$route.matched.length > 3?true:false,"text":wbgroup.name},on:{"clickAdd":function($event){return _vm.createUObject({
                url: [
                  {projects: _vm.project.id},
                  {wbgroups: wbgroup.id},
                  {wblines: ''},
                  {showWithEntitiesNormalized: ''}
                ],
                u_object: {
                  name: 'New Line',
                  description: 'description'
                }
              })},"clickDelete":function($event){return _vm.deleteUObject({
                url: [
                  {projects: _vm.project.id},
                  {wbgroups: wbgroup.id}
                ],
                trainsbacklogs: true
              })},"changeValue":function($event){return _vm.updateUObject({
              url: [
                {projects: _vm.project.id},
                {wbgroups: wbgroup.id}
              ],
              update: {
                name: $event.target.value
              }
              })}}},_vm._l((_vm.getUObjects({type: 'wblines', ids: wbgroup.wblines})),function(wbline){return _c('BacklogWrapper',{key:`wblines-${wbline.id}`,attrs:{"isEditMode":_vm.isEditMode,"color":"#757575","icon":"crop_free","type":"wblines","header_sticky_position":"50px","small_width":_vm.$route.matched.length > 3?true:false,"text":wbline.name},on:{"clickDelete":function($event){wbgroup.wblines.length === 1?
              _vm.deleteUObject({
                  url: [
                    {projects: _vm.project.id},
                    {wbgroups: wbgroup.id}
                  ],
                  trainsbacklogs: true,
                })
              :
              _vm.deleteUObject({
                  url: [
                    {projects: _vm.project.id},
                    {wbgroups: wbgroup.id},
                    {wblines: wbline.id}
                  ]
                })},"clickAdd":function($event){_vm.$router.push({
                  name: 'TaktPlanAddWBWorkPackage',
                  params: {
                    wbgroup_id: wbgroup.id,
                    wbline_id: wbline.id
                  }
                }),
                _vm.setNewWPPosition(false)},"changeValue":function($event){return _vm.updateUObject({
                url: [
                  {projects: _vm.project.id},
                  {wbgroups: wbgroup.id},
                  {wblines: wbline.id}
                ],
                update: {
                  name: $event.target.value
                }
                })}}},_vm._l((_vm.getWBWorkpackagesSorted(wbline).filter(wbworkpackage => {
                  if(_vm.$store.state.View.backglogs_show_with_date) {
                    return wbworkpackage.position === -1
                  } else {
                    return true
                  }
                })),function(wbworkpackage){return _c('BacklogWorkpackageList',{key:`wblines-${wbworkpackage.id}`,attrs:{"wbworkpackage":wbworkpackage,"date":_vm.getWBWorkpackageDate(wbworkpackage, _vm.project.id),"small_width":_vm.$route.matched.length > 3?true:false},on:{"updatePosition":function($event){return _vm.updateUObject({
                    url: [
                      {projects: _vm.project.id},
                      {wbgroups: wbgroup.id},
                      {wblines: wbline.id},
                      {wbworkpackages: wbworkpackage.id}
                    ],
                    update: {
                      position: $event
                    }
                })},"updateLength":function($event){return _vm.updateUObject({
                    url: [
                      {projects: _vm.project.id},
                      {wbgroups: wbgroup.id},
                      {wblines: wbline.id},
                      {wbworkpackages: wbworkpackage.id}
                    ],
                    update: {
                      length: $event
                    }
                })},"clickRemove":function($event){return _vm.updateUObject({
                    url: [
                      {projects: _vm.project.id},
                      {wbgroups: wbgroup.id},
                      {wblines: wbline.id},
                      {wbworkpackages: wbworkpackage.id}
                    ],
                    update: {
                      position: -1,
                      length: 1,
                    }
                })}},nativeOn:{"click":function($event){return _vm.$router.push({
                  name: 'TaktPlanBacklogWorkPackageInfo',
                  params: {
                    wbgroup_id: wbgroup.id,
                    wbline_id: wbline.id,
                    wbworkpackage_id: wbworkpackage.id
                  }
                })}}})}),1)}),1)}),1),_c('div',{staticStyle:{"position":"relative","width":"100%","height":"calc(100% - 50px)","overflow":"hidden"}},[_c('router-view')],1)])],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }